import React from 'react';

export default function FilterChip({
  label,
  active = false,
  onClick,
  disabled = false,
  title,
  selection = 'single',
}) {
  return (
    <button
      type="button"
      className={active ? 'wt-filter-chip is-active' : 'wt-filter-chip'}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={active}
      title={title || label}
      data-selection={selection}
    >
      {label}
    </button>
  );
}
